import React, {Component} from 'react';

/* global $ */

class FeedbackModal extends Component {
    constructor(props){
        super(props);
        
        this.state = {
            content: ''
        }
    }
    
    sendFeedback = () => {
        let item = {
            content: this.state.content,
            profileId: this.props.profile.id,
            onPage: window.location.href,
            courseId: this.props.courseId
        }
        
        this.props.sendFeedback(item, this.props.user.id);
        $('#SendFeedbackModal').modal('hide');
        this.props.dismiss();
    }
    
    componentDidMount(){
        $('#SendFeedbackModal').modal('show');
    }
    
    dismiss = () => {
        $('#SendFeedbackModal').modal('show');
        this.props.dismiss();
    }
    
    render(){
        
        return (
            <div className="modal fade in" id="SendFeedbackModal" tabindex="-1" role="dialog" aria-labelledby="SendFeedbackModalLabel">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={e => this.dismiss()}><span aria-hidden="true">×</span></button>
                                <h4 className="modal-title" id="SendFeedbackModalLabel">Send Feedback</h4>
                            </div>
                            <div className="modal-body no-padding">
                                <div className="modal-body">
                            
                                <div className="form-group">
                                    <label>Details</label>
                                    <textarea className="form-control" rows="5" style={{height: "200px"}} value={this.state.content} onChange={e => this.setState({content: e.target.value})}></textarea>
                                </div>
                           
                        </div>
                            
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-default" data-dismiss="modal" onClick={e => this.dismiss()}>Close</button>
                            <button type="button" className="btn btn-success" data-dismiss="modal" onClick={e => this.sendFeedback()}>Send Feedback</button>
                        </div>
                    </div>
                </div>
            </div>    
        )
    }
}

export default FeedbackModal;


// WEBPACK FOOTER //
// ./src/components/Video/FeedbackModal.js